"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ui_components_1 = require("@l2p/ui-components");
var apps_shared_1 = require("@l2p/apps-shared");
var next_intl_1 = require("next-intl");
var swr_hooks_1 = require("@l2p/swr-hooks");
var TimeLeft_1 = __importDefault(require("../CurrentLotteryCard/TimeLeft"));
var Conditions_1 = __importDefault(require("./Conditions"));
var ButtonWithTimer_1 = __importDefault(require("./ButtonWithTimer"));
var LotteryDetailedBanner = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var t = (0, next_intl_1.useTranslations)('lottery');
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var openSignUp = (0, apps_shared_1.useOpenSignUp)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var config = (0, swr_hooks_1.useConfig)();
    var bannerImage = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d;
        return Object.keys(breakpoints).length > 0 && breakpoints.mobile
            ? (_b = (_a = props.baseLottery) === null || _a === void 0 ? void 0 : _a.images) === null || _b === void 0 ? void 0 : _b.mobileBackground
            : (_d = (_c = props.baseLottery) === null || _c === void 0 ? void 0 : _c.images) === null || _d === void 0 ? void 0 : _d.background;
    }, [
        breakpoints,
        (_b = (_a = props.baseLottery) === null || _a === void 0 ? void 0 : _a.images) === null || _b === void 0 ? void 0 : _b.mobileBackground,
        (_d = (_c = props.baseLottery) === null || _c === void 0 ? void 0 : _c.images) === null || _d === void 0 ? void 0 : _d.background,
    ]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.banner, style: {
            backgroundImage: "url(".concat(bannerImage, ")") || 'initial',
        } },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.firstTitle }, t('lottery')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.budget }, translateLocale((_e = props.baseLottery) === null || _e === void 0 ? void 0 : _e.budget)),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, translateLocale((_f = props.baseLottery) === null || _f === void 0 ? void 0 : _f.title)),
                !props.isFinished ? (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_1.default.Fragment, null, !((_g = config === null || config === void 0 ? void 0 : config.lotteries) === null || _g === void 0 ? void 0 : _g.buttonWithTimer) ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.timerContainer },
                        react_1.default.createElement(TimeLeft_1.default, { date: props.endDate }))) : null),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.depositBtnContainer }, ((_h = config === null || config === void 0 ? void 0 : config.lotteries) === null || _h === void 0 ? void 0 : _h.buttonWithTimer) ? (react_1.default.createElement(ButtonWithTimer_1.default, { onButtonClick: isAuth ? openDeposit : openSignUp, text: isAuth ? t('deposit') : t('signup'), endDate: props === null || props === void 0 ? void 0 : props.endDate })) : (react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", width: "auto", maxWidth: "100%", text: "upper", className: "deposit-btn", onClick: isAuth ? openDeposit : openSignUp }, isAuth ? t('deposit') : t('signup')))))) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.finished }, t('finished')))),
            react_1.default.createElement(Conditions_1.default, __assign({}, props)))));
};
exports.default = LotteryDetailedBanner;
